import { styled } from 'styled-components'
import { RightArrowIcon } from '../../../icons'
import { onMediumScreen } from 'mixtiles-web-common'

export const Container = styled.div`
  display: flex;
  padding: 12px 0 15px 0;
  color: ${({ theme }) => theme.colors.grayDark};
  cursor: pointer;
  &:hover {
    ${onMediumScreen()} {
      color: ${({ theme }) => theme.colors.black};
    }
  }
  transition: color 0.2s;
`

export const Option = styled.div`
  font-size: 17px;
  font-weight: 500;
  align-self: center;
`

export const Arrow = styled(RightArrowIcon)`
  width: 22px;
  height: 22px;
`
